import { Fragment } from 'react'

import BasicAlgebra from '~/components/Drill/DrillTopic/BasicAlgebra/BasicAlgebra'
import Equations from '~/components/Drill/DrillTopic/Equations/Equations'
import Factorization from '~/components/Drill/DrillTopic/Factorization/Factorization'
import Fractions from '~/components/Drill/DrillTopic/Fractions/Fractions'
import Functions from '~/components/Drill/DrillTopic/Functions/Functions'
import Parentheses from '~/components/Drill/DrillTopic/Parentheses/Parentheses'
import Percent from '~/components/Drill/DrillTopic/Percent/Percent'
import Powers from '~/components/Drill/DrillTopic/Powers/Powers'
import TheMultiplicationTable from '~/components/Drill/DrillTopic/TheMultiplicationTable/TheMultiplicationTable'
import { last } from '~/utils/helpers'
import { DRILL_TOPIC_TITLES } from '~/shared/constants/drill.const'
import { DrillTopicOverview } from '~/types/theory'

export default function DrillTopicRenderer({ topic }: { topic: DrillTopicOverview }): React.ReactElement {
  const { path, children } = topic
  const pathParam = last(path.split('/'))

  switch (true) {
    case DRILL_TOPIC_TITLES.BASIC_ALGEBRA.includes(pathParam):
      return <BasicAlgebra drillUrl={path} topics={children} />

    case DRILL_TOPIC_TITLES.EQUATIONS.includes(pathParam):
      return <Equations drillUrl={path} topics={children} />

    case DRILL_TOPIC_TITLES.FACTORIZATION.includes(pathParam):
      return <Factorization drillUrl={path} topics={children} />

    case DRILL_TOPIC_TITLES.FRACTIONS.includes(pathParam):
      return <Fractions drillUrl={path} topics={children} />

    case DRILL_TOPIC_TITLES.FUNCTIONS.includes(pathParam):
      return <Functions drillUrl={path} topics={children} />

    case DRILL_TOPIC_TITLES.PARENTHESES.includes(pathParam):
      return <Parentheses drillUrl={path} topics={children} />

    case DRILL_TOPIC_TITLES.PERCENT.includes(pathParam):
      return <Percent drillUrl={path} topics={children} />

    case DRILL_TOPIC_TITLES.POWERS.includes(pathParam):
      return <Powers drillUrl={path} topics={children} />

    case DRILL_TOPIC_TITLES.THE_MULTIPLICATION_TABLE.includes(pathParam):
      return <TheMultiplicationTable drillUrl={path} topics={children} />

    default:
      return <Fragment />
  }
}
